//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../Routing/Routing.ObjectRelationship.js";
let d=[[[0,"RelationshipType",1,0]],[[[],"GetRelatingSingleDevice",{R_:{relating_device:"Routing.SingleDevice"}},0,0],[["relating_device"],"SetRelatingSingleDevice",{},1,0],[["n_related"],"GetRelatedSingleDevices",{R_:{related_devices:"Routing.SingleDevice[]"}},0,0],[["related_device"],"AddRelatedSingleDevice",{},1,0],[["related_device"],"RemoveRelatedSingleDevice",{},1,0],[["related_devices"],"ReplaceRelatedSingleDevices",{},1,0]],[]];
SPLM.Routing.DeviceRelationship = class extends SPLM.Routing.ObjectRelationship{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.DeviceRelationship";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.DeviceRelationship.RelationType = Object.freeze({
    "AssociatedEquipment" : "AssociatedEquipment"});

export default SPLM;